import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "config/api";
import { SendSoundRequest } from "interfaces/requests/Sounds";

const BASE_URL = "/sounds";

export const emitSound = createAsyncThunk(
  "sounds/post",
  async (request: SendSoundRequest) => {
    try {
      const response = await axios.post(`${BASE_URL}/`, request);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - sendSound ->", error);
      throw new Error(error.message);
    }
  },
);
